import { render, staticRenderFns } from "./AppColorPicker.vue?vue&type=template&id=2676b8c6&"
import script from "./AppColorPicker.vue?vue&type=script&lang=ts&"
export * from "./AppColorPicker.vue?vue&type=script&lang=ts&"
import style0 from "./AppColorPicker.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VColorPicker } from 'vuetify/lib/components/VColorPicker';
import { VMenu } from 'vuetify/lib/components/VMenu';
installComponents(component, {VColorPicker,VMenu})
